import type { TrackModel } from "../../models/models";
import { AUDIO_TYPE, COLLECTION_IDS } from "../../models/dictionary";

export const moodscapeTracks: TrackModel[] = [
	{
		id: "d4fccf6b-4536-4c91-8f39-ec32369623fe",
		type: AUDIO_TYPE.TRACK,
		name: "Glass Sky",
		slug: "glass-sky",
		audioUrlStub: "https://audios.coffitivity.com/glass-sky",
		imageUrlStub: "https://images.coffitivity.com/glass-sky",
		description:
			"Smooth, reflective ambiance with a delicate, otherworldly shine.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		blend: null,
		albumId: "33156d32-82d5-4b0c-a3aa-5ecebe42f1ca",
		collectionId: COLLECTION_IDS.MOODSCAPE,
		effectIds: ["effects:focus", "effects:creativity", "effects:meditation"],
		createdAt: "2025-10-20 21:02:41.411475+00",
		updatedAt: "2025-10-20 21:02:41.411475+00",
		releaseDate: "2025-04-30 21:02:08+00",
	},
	{
		id: "a15ed200-c513-4acd-9fb3-acdabe6f0d3b",
		type: AUDIO_TYPE.TRACK,
		name: "Weightless",
		slug: "weightless",
		audioUrlStub: "https://audios.coffitivity.com/weightless",
		imageUrlStub: "https://images.coffitivity.com/weightless",
		description:
			"Spacious and floaty ambiance that clears the mind and lifts the mood.",
		isPremium: true,
		isLooping: true,
		userId: null,
		location: null,
		blend: null,
		albumId: "33156d32-82d5-4b0c-a3aa-5ecebe42f1ca",
		collectionId: COLLECTION_IDS.MOODSCAPE,
		effectIds: ["effects:focus", "effects:creativity", "effects:stimulation"],
		createdAt: "2025-10-20 21:03:37.432411+00",
		updatedAt: "2025-10-20 21:03:37.432411+00",
		releaseDate: "2025-04-30 21:03:13+00",
	},
];
